module.exports = __webpack_public_path__ + "img/share.66742494.svg";